import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ExamShellProvider } from "./context/ExamShellContext";

import Login from "./pages/Login";
import Instructions from "./pages/Instructions";
import Dashboard from "./pages/Dashboard";
import SecondLevelExam from "./pages/SecondLevelExam";
import Summary from "./pages/Summary";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

/*
 * The candidate-facing pages (login -> instructions -> dashboard ->
 * summary, plus the standalone second-level-exam) all share one
 * ExamShellProvider instance so the fullscreen lock, start gate and resume
 * gate persist across navigation between them — exactly like the original
 * portal.html shell persisted across the framed pages it hosted.
 *
 * The admin pages never ran inside that shell in the original project
 * (admin_login.html / admin_dashboard.html have no exam-lock.js include),
 * so they are routed outside the provider.
 */
function CandidateShell() {
  return (
    <ExamShellProvider>
      <Routes>
        <Route index element={<Navigate to="login" replace />} />
        <Route path="login" element={<Login />} />
        <Route path="instructions" element={<Instructions />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="second-level-exam" element={<SecondLevelExam />} />
        <Route path="summary" element={<Summary />} />
        <Route path="*" element={<Navigate to="login" replace />} />
      </Routes>
    </ExamShellProvider>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
      <Route path="/*" element={<CandidateShell />} />
    </Routes>
  );
}
